// extracted by mini-css-extract-plugin
export default {"container":"TestCanvas_container__DvUx4"};